import React, { useEffect, useState } from 'react';
import OneBlog from '../Certificate/OneBlog';
import Loading from '../Shared/Loading';

function College() {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const [myData, setMyData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(6);


  useEffect(() => {
  fetch(`https://education-info-server-production.up.railway.app/college?page=${page}&size=${size}`)
    .then(response => response.json())
    .then(json => setMyData(json))
  }, [page,size])

  useEffect(() => {
    fetch('https://education-info-server-production.up.railway.app/serviceCountTwo')
    .then(res=>res.json())
    .then(data =>{
        const count = data.count;
        const pages = Math.ceil(count/6);
        setPageCount(pages);
    })
}, [])


const handleSearch = event => {
  setSearchTerm(event.target.value.trim());
  const filteredResults = myData.filter(service => service.Title.toLowerCase().includes(searchTerm.toLowerCase()) || service.Location.toLowerCase().includes(searchTerm.toLowerCase()) || service.Date.toLowerCase().includes(searchTerm.toLowerCase()));
  setSearchResults(filteredResults);
};




  return (
    <>
    
    <div className='add-service1'>
    <h2 className='text-white text-2xl text-center font-semibold py-4'>College Information</h2>
       <p className="paraText px-12"> 
         <span style={{fontWeight:700}}>College information</span> helps students make informed decisions about their educational choices. This includes information about the curriculum, faculty, student life, career services, financial aid, and other important factors. <br />
        <span style={{fontWeight:700}}>College information</span> provides students with an understanding of the job market and the skills and qualifications needed to succeed in their chosen fields. It also helps them explore various career options and make informed decisions about their future careers.<br />
     </p>
     </div>

     <div className='my-6 text-center'>
       <input type="text" placeholder="Search by title, location, Date" style={{borderRadius:'0px'}} className="input input-bordered w-2/3 lg:w-2/5" onChange={handleSearch}/>
     </div>

    {myData.length === 0 ? <Loading /> :
      <>
  
       <div style={{marginBottom:'50px'}} className=" py-6 px-12 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-6 gap-10">

       {(searchTerm.length === 0) && myData.map(service => (
           
           <OneBlog
           key={service._id}
           service={service}
           ></OneBlog>
         ))
      }

       {(searchTerm.length !== 0) && searchResults.map(service => (
                 <OneBlog
                 key={service._id}
                 service={service}
                 ></OneBlog>)
                 )}

      
    </div>

    <div className='pagination'>
                    {
                        [...Array(pageCount).keys()].map(number =><button
                        className={page === number ? 'selected' : ''}
                        onClick={()=>setPage(number)}
                        >{number + 1}</button>)
                    }
                   <select className='selector' onChange={e=> setSize(e.target.value)}>
                        <option value ='6' selected>6</option>
                        <option value ='12'>12</option>
                        <option value ='18'>18</option>
                        <option value ='24'>24</option>
                    </select>
                </div>

                {/* pagination */}


    </>
    }

            
    </>
                  
  )
}

export default College
